import ModalsInfoLib from '../../lib/modals-info';

export default () => {
    return (
        <div className="modal-info-container">
            <div className="modal-info animate__animated animate__fadeInUp animate__faster">
                <div className="close-button" onClick={e => ModalsInfoLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>

                <div className="modal-info-content">
                    <div className="modal-info-image">
                        <img src={`${window.location.origin}/source/system/modal-info/vip-20-random-boost-info.png`} alt="" />
                    </div>

                    <div className="modal-info-body">
                        <div className="modal-info-body-content">
                            <p>
                                <h1>Random Boost</h1>

                                <span>Random Boost is a time-limited bonus that increases your deposits for a short period.</span>
                                <span>When active, you receive an extra percentage on every deposit you make during the boost window.</span>
                                <span>The bonus is applied to the final deposit amount (after any fees, if applicable).</span>
                            </p>

                            <p>
                                <h2>How does Random Boost work?</h2>
                                <span>Random Boost is available through VIP and must be claimed before it can be used.</span>
                                <span>Once claimed, it becomes active for a limited time and applies to all deposits made during that period.</span>
                                <span>The boost amount and duration may vary (for example: <b>+20%</b> for <b>2 hours</b>).</span>
                            </p>

                            <p>
                                <h2>Can it stack with other bonuses?</h2>
                                <span>No. Random Boost does not stack with any other deposit bonuses.</span>
                                <span>If Random Boost is active, it overrides any other deposit bonus offers for its duration.</span>
                            </p>

                            <p>
                                <h2>How do I get Random Boost?</h2>
                                <span>Random Boost is granted randomly to VIP players for a limited time.</span>
                                <span>When it becomes available, you will receive a notification and will need to claim it before it expires.</span>
                            </p>

                            <p>
                                <h2>Does VIP level affect Random Boost?</h2>
                                <span>There is no fixed bonus per VIP level.</span>
                                <span>However, the higher your VIP level, the higher your chances of receiving stronger boosts.</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-info-overlay animate__animated animate__fadeIn animate__faster"></div>
        </div>
    )
}